<ng-container *ngFor="let child of inputChildren; let i = index">
  <button id="top-mat-menu-item" class="menu-item"
    *ngIf="child.isChildrenFlg && isTopSideComponent && !notViewList.includes(child.itemId)" mat-menu-item
    [matMenuTriggerFor]="menu">{{child.title}}</button>

  <button id="child-mat-menu-item" *ngIf="child.isChildrenFlg && !isTopSideComponent" mat-menu-item
    [matMenuTriggerFor]="menu">{{child.title}}</button>

  <button id="top-mat-button" class="menu-item" *ngIf="!child.isChildrenFlg && !notViewList.includes(child.itemId)"
    (click)="onClick(child.pathInfo, child.itemId)" [ngClass]="{'black-text': isSelected(child.itemId)}"
    mat-menu-item>{{child.title}}</button>

  <mat-menu #menu="matMenu">

    <ng-container *ngFor="let node of getChildren(child.itemId); let i = index">

      <div *ngIf="node.isChildrenFlg && !notViewList.includes(node.itemId)">
        <button mat-menu-item><app-child-side-menu [inputChildren]="filterChildren(node.parentItemId)"
            [inputIsTopSideComponent]="false" [inputAuthorityList]="authorityList"
            [inputNotViewList]="notViewList"></app-child-side-menu></button>
      </div>

      <div *ngIf="!node.isChildrenFlg && !notViewList.includes(node.itemId)">
        <button id="child-mat-button" class="button-item" (click)="onClick(node.pathInfo, node.itemId)"
          [ngClass]="{'black-text-child': isSelected(node.itemId)}" mat-menu-item>{{node.title}}</button>
      </div>

    </ng-container>

  </mat-menu>
</ng-container>